import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
const ProductsPage = () => {
    const { t } = useTranslation();
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "h4", gutterBottom: true, children: t('products.title') }), _jsx(Typography, { variant: "body1", color: "text.secondary", children: t('products.placeholder') })] }));
};
export default ProductsPage;
